import { ColorName, SkeletonText, Text } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { Handles } from "../../../../Handles";
import { AssetPreview } from "../../AssetNodeSkeleton/AssetPreview";
import { getContrastingTextColor } from "../../AssetNodeSkeleton/utils";
import styles from "./LoadingZapNode.module.css";

/* IMPORTANT! We need Handles in the loading state or else the edges won't get rendered even though they exist */
export function LoadingZapNode({
  id,
  color,
  backgroundColor,
}: {
  id: string;
  color: string;
  backgroundColor: string;
}) {
  return (
    <>
      <div
        className={styles.loadingContainer}
        style={{
          backgroundColor: color,
        }}
      >
        <Handles nodeType="zap" />
        <div className={styles.loadingBodyContainer}>
          <div
            className={styles.loadingBody}
            style={{
              backgroundColor,
            }}
          >
            <div className={styles.loadingPreviewImage}>
              <AssetPreview id={id} assetType="zap" />
            </div>
            <SkeletonText
              lines={2}
              size="body"
              textAlign="left"
              width="100%"
              color="GrayWarm3"
            />
          </div>
        </div>
        <div className={styles.loadingFooter}>
          <div className={styles.loadingIconContainer}>
            <Icon name="miscBoltAltFill" color="BrandOrange" size={16} />
          </div>
          <Text
            type="MinimalPrint1"
            color={getContrastingTextColor(color!) as ColorName}
          >
            Zap
          </Text>
        </div>
      </div>
    </>
  );
}
